import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import CloseIcon from '@mui/icons-material/Close';
import { Box, ButtonBase, Modal, SxProps } from '@mui/material';

import * as S from './styles';

type ConfirmModalProps = {
  open: boolean;
  img?: string;
  onClose: () => void;
  onConfirm?: () => void;
  confirmText?: string;
  isDelateStyle?: boolean;
  children?: ReactNode;
  contentSx?: SxProps;
};

export function ConfirmModal({
  open,
  img,
  onClose,
  onConfirm,
  confirmText,
  isDelateStyle,
  children,
  contentSx = {},
}: ConfirmModalProps) {
  const { t } = useTranslation();

  return (
    <Modal
      onClose={onClose}
      open={open}
      sx={{ display: 'flex' }}
      slotProps={{
        backdrop: {
          sx: S.backDropOverlay,
        },
      }}
    >
      <Box sx={[S.confirmModalContainer, contentSx] as SxProps}>
        <CloseIcon className="close-icon" onClick={onClose} />
        {img && <img className="modal-img" src={img} alt="Modal image" />}
        {children}
        {onConfirm && (
          <Box sx={S.buttonGroup}>
            <ButtonBase sx={S.cancelBtn} onClick={onClose}>
              {t('buttons:cancel')}
            </ButtonBase>
            <ButtonBase sx={S.confirmBtn} className={isDelateStyle ? 'danger-btn' : ''} onClick={onConfirm}>
              {confirmText}
            </ButtonBase>
          </Box>
        )}
      </Box>
    </Modal>
  );
}
